import { Box, Typography } from '@mui/material';
import React from 'react';
import logoAlertAiEducation from '../../../../assets/images/favicon.png';
import walpaperAdventista from '../../../assets/adventista.jpg';
import defaultImagePage4 from '../../../../assets/images/proposalImagens/childrenImage.jpeg';

interface PdfViewerProps {
  formData: { imagePage4?: File | null; monthlyCall?: string };
  formaDataContext?: { logos?: (File | null)[] };
  boxRef: React.Ref<unknown>;
}

const PdfViewerFourth: React.FC<PdfViewerProps> = ({
  formData,
  boxRef,
  formaDataContext,
}) => {
  return (
    <Box
      sx={{
        width: '95vw',
        height: '90vh',
        maxWidth: 'calc(93vh * 0.700)',
        aspectRatio: '1 / 1.414',
        backgroundColor: 'white',
        boxShadow: '0 2px 12px rgba(0,0,0,0.10)',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        margin: 'auto',
        position: 'relative',
      }}
      ref={boxRef}
    >
      <Box
        sx={{
          height: '100%',
          width: '7vh',
          backgroundColor: '#224FA2',
        }}
      />

      <div style={{ width: '100%' }}>
        <Typography
          sx={{
            fontSize: '2.5rem',
            width: '60%',
            fontWeight: 'bold',
            color: '#224FA2',
            marginBottom: '1rem',
            lineHeight: 1,
            paddingLeft: '24px',
          }}
        >
          Chamada de alunos
        </Typography>
        <Box
          sx={{
            width: '40%',
            height: '5px',
            marginLeft: '24px',
            marginBottom: '2rem',
            backgroundColor: '#54B55D',
            zIndex: 1,
          }}
        />
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'flex-start',
            width: '100%',
            height: '18vh',
            marginBottom: '1rem',
            paddingLeft: '25px',
          }}
        >
          <img
            src={
              formData.imagePage4
                ? URL.createObjectURL(formData.imagePage4)
                : defaultImagePage4
            }
            alt="Painel ilustrativo"
            style={{
              width: '19vh',
              height: 'auto',
            }}
          />
        </Box>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'flex-start',
            width: '100%',
            height: '15vh',
            marginBottom: '1rem',
            paddingLeft: '25px',
          }}
        >
          <Typography
            sx={{
              fontSize: '0.7rem',
              width: '100%',
              fontWeight: 'bold',
              color: '#224FA2',
              lineHeight: 1,
            }}
          >
            O sistema pode realizar automaticamente a chamada de presença dos
            alunos através de reconhecimento facial.
            <br />
            <br />
            Isso elimina a necessidade de chamadas manuais, economizando tempo
            dos professores e garantindo que a presença seja registrada de forma
            precisa e automatizada, além de poder ser integrado ao sistema de
            gestão escolar para relatórios de frequência
          </Typography>
        </Box>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-start',
            paddingLeft: '25px',
            marginBottom: '1rem',
          }}
        >
          <table style={{ borderCollapse: 'collapse', minWidth: 200 }}>
            <thead>
              <tr>
                <th
                  style={{
                    border: '1px solid #224FA2',
                    padding: '8px 18px',
                    fontWeight: 'bold',
                    color: '#224FA2',
                    height: '10px',
                    fontSize: '0.9rem',
                    background: '#F5F8FF',
                    textAlign: 'left',
                  }}
                >
                  Mensalidade
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td
                  style={{
                    border: '1px solid #224FA2',
                    padding: '12px 24px',
                    fontWeight: 'bold',
                    height: '10px',
                    color: 'gray',
                    fontSize: '0.8rem',
                  }}
                >
                  {formData.monthlyCall || '-'}
                </td>
              </tr>
            </tbody>
          </table>
        </Box>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'flex-start',
            width: '100%',
            height: '2vh',
            marginBottom: '1rem',
            paddingLeft: '25px',
          }}
        >
          <Typography
            sx={{
              fontSize: '0.7rem',
              width: '100%',
              fontWeight: 'bold',
              color: '#224FA2',
              lineHeight: 1,
            }}
          >
            O sistema pode realizar automaticamente a chamada de presença dos
            alunos através de reconhecimento facial.
          </Typography>
        </Box>
        <Box
          sx={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: 2,
            width: '100%',
            mt: '2rem',
            height: '6vh',
            paddingLeft: '24px',
          }}
        >
          {(formaDataContext?.logos ?? [])
            .filter((logo): logo is File => logo instanceof File)
            .map((logo, index) => (
              <img
                key={index}
                src={URL.createObjectURL(logo)}
                alt={`Logo ${index + 1}`}
                style={{
                  height: '100%',
                  maxHeight: '100%',
                  objectFit: 'contain',
                }}
              />
            ))}

          <img
            src={logoAlertAiEducation}
            alt="Logo AlertAi"
            style={{
              height: '100%',
              objectFit: 'contain',
            }}
          />
        </Box>
      </div>
    </Box>
  );
};

export default PdfViewerFourth;
